import filterMixin from './filterMixin'
import WithFilter from './WithFilter'

export class FilterBuilder extends filterMixin() {
  get constructorName() {
    return 'FilterBuilder'
  }

  _build() {
    return this.getFilterModel()
  }
}

export class PlatformizedFilterBuilder
  extends filterMixin()
  implements WithFilter<PlatformizedFilterBuilder>
{
  in(...args: any[]) {
    return this._AndSetOperand('$in', '.in', args)
  }

  exists(...args: any[]) {
    return this._binaryAnd('$exists', '.exists', args)
  }

  gte(field: any, value: any) {
    return this.ge(field, value)
  }

  lte(field: any, value: any) {
    return this.le(field, value)
  }

  build() {
    return this.getFilterModel()
  }

  hasAnyFilter(): boolean {
    if (this.filterTree === null || this.filterTree === undefined) {
      return false
    }
    if (!Object.keys(this.filterTree).every((x) => x === '$and')) {
      return false
    }
    return (this.filterTree?.$and?.length ?? 0) > 0
  }
}

export function platformizedFilterBuilder(options = {}) {
  return new PlatformizedFilterBuilder(options)
}

export function filterBuilderFactory() {
  return new FilterBuilder({})
}

export default filterBuilderFactory
